import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const containerRowRecipeFn = /* @__PURE__ */ createRecipe('containerRow', {}, [])

const containerRowRecipeVariantMap = {}

const containerRowRecipeVariantKeys = Object.keys(containerRowRecipeVariantMap)

export const containerRowRecipe = /* @__PURE__ */ Object.assign(memo(containerRowRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'containerRowRecipe',
  __getCompoundVariantCss__: containerRowRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: containerRowRecipeVariantKeys,
  variantMap: containerRowRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, containerRowRecipeVariantKeys)
  },
  getVariantProps: containerRowRecipeFn.getVariantProps,
})